<mat-dialog-content class="content-pad text-left">
  <div class="nxt-dialog-wrapper d-flex flex-column align-items-start text-left w-100">
    <div class="d-flex justify-content-between align-items-start w-100 mb-3">
      <div class="d-flex align-items-start flex-grow-1 pr-2 min-w-0">
        <span class="text-warning nxt-font-20 mr-2 nxt-pt-2 flex-shrink-0" aria-hidden="true">
          <i class="nxticon-warning-line"></i>
        </span>
        <h4 class="title-text m-0 text-left">{{ headline }}</h4>
      </div>
      <button type="button" class="btn p-0 text-muted flex-shrink-0" mat-dialog-close aria-label="Close">
        <i class="nxticon-close nxt-font-16"></i>
      </button>
    </div>

    <p *ngIf="bodySummary" class="nxt-black nxt-regular m-0 nxt-pb-8">{{ bodySummary }}</p>

    <div class="w-100 nxt-mt-5 rate-limit-dialog__bot-list">
      <div
        *ngFor="let bot of resourcesForUi; let last = last"
        class="border rounded bg-white nxt-p-16"
        [class.mb-3]="!last"
      >
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="d-flex align-items-center min-w-0 mr-2 nxt-gap-4">
            <img src="{{assetsUrl}}assets/images/{{channel}}.png" width="20px">
            <span class="nxt-font-14 font-weight-bold font-color-black text-truncate">{{ resourceDisplayName(bot) }}</span>
          </div>
          <ng-container *ngIf="resourceHasUsage(bot)">
            <span *ngIf="botLimitReached(bot)" class="nxt-font-13 font-weight-semibold text-danger flex-shrink-0"
              >Limit reached</span
            >
            <span *ngIf="!botLimitReached(bot)" class="nxt-font-13 text-secondary flex-shrink-0"
              >{{ botPercent(bot) }}%</span
            >
          </ng-container>
          <span *ngIf="!resourceHasUsage(bot)" class="nxt-font-13 text-secondary flex-shrink-0 text-uppercase">{{
            bot['account_type'] || 'live'
          }}</span>
        </div>

        <ng-container *ngIf="resourceHasUsage(bot)">
          <div class="progress mb-2 rate-limit-dialog__progress">
            <div
              class="progress-bar rate-limit-dialog__progress-bar"
              [class.bg-danger]="botLimitReached(bot)"
              [class.bg-success]="!botLimitReached(bot)"
              role="progressbar"
              [attr.aria-valuenow]="botLimitReached(bot) ? 100 : botPercent(bot)"
              aria-valuemin="0"
              aria-valuemax="100"
              [style.--rate-progress]="(botLimitReached(bot) ? 100 : botPercent(bot)) + '%'"
            ></div>
          </div>

          <div class="d-flex justify-content-between note-text nxt-font-12">
            <span>{{ bot['sent'] }} sent</span>
            <span>{{ bot['daily_limit'] }} limit</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="actions-pad">
  <button type="button" class="btn btn-primary btn-lg nxt-btn-lg h-40 w-40" mat-dialog-close>OKAY</button>
</mat-dialog-actions>
